<template>
  <div class="orders-table-container">
    <BaseTable
      ref="orders-table"
      :columns="columns"
      :filters="baseFilters"
      :totals-configuration="totalsConfiguration"
      :resource="$data.$constants.RESOURCES.RESOURCE_ORDERS"
      :resourceStore="'orders'"
      :loading="loading"
      :excluded-filters="baseExcludeFilters"
      @filter-button-click="filtersVisible = !filtersVisible"
      @on-clear-active-filters="handleClearOfferListFilters"
      @row-clicked="$router.push({ name: 'viewOrder', params: { id: $event.id } })"
    >
      <template #cell(job)="data">
        <span> {{ data.item.job.code }} </span>
      </template>
      <template #cell(order_date)="data">
        {{ new Date(data.item.order_date).toLocaleDateString() }}
      </template>
      <template #cell(provider)="data">
        <span> {{ data.item.provider.name }} </span>
      </template>
      <template #cell(pending_billing)="{ value }">
        <div> {{ value | numberToLocalString }} €</div>
      </template>
      <template #cell(total_gross)="{ value }">
        <div> {{ value | numberToLocalString }} €</div>
      </template>
      <template #cell(total_order)="{ value }">
        <div> {{ value | numberToLocalString }} €</div>
      </template>
      <template #cell(status)="data">
        <StatusBadge
          :status="data.item.status.name"
          :text="getStatusText(data.item)"
        />
      </template>
      <template #cell(status_notes)="data">
        <StatusBadge
          :status="data.item.status_notes.name"
        />
      </template>
      <template #cell(invoices_incidents)="data">
        <div v-if="data.item.invoices_incidents && data.item.invoices_incidents.length > 0">
          <button class="btn rounded-pill btn-warning btn-sm" @click.stop="showIncidentsModal(data.item.invoices_incidents, data.item)">Resolver incidencias</button>
        </div>
      </template>
      <template #cell(actions)="data">
        <feather-icon
            v-show="data.item.pm_comments"
            :id="`popover-target-${data.item.id}`"
            icon="InfoIcon"
            size="18"
            class="text-indigo mr-1"
        />
        <b-popover :target="`popover-target-${data.item.id}`" triggers="hover" placement="top">
          <template #title>Anotaciones PM</template>
          <pre style="background: #ffff;">{{ data.item.pm_comments }}</pre>
        </b-popover>
        <b-link class="d-inline-block text-indigo">
          <feather-icon
            v-b-tooltip.hover
            title="Descargar pedido"
            icon="DownloadIcon"
            size="18"
            @click.stop="handlePrintLinkClick(data.item.id)"
          />
        </b-link>
        <b-link
          :to="{ name: 'viewOrder', params: { id: data.item.id} }"
          class="px-1 d-inline-block text-indigo"
        >
          <feather-icon
            v-b-tooltip.hover
            title="Ver"
            icon="EyeIcon"
            size="18"
          />
        </b-link>
        <b-link
          v-access="{
            resource: $data.$constants.RESOURCES.RESOURCE_ORDERS,
            resourceAction: $data.$constants.RESOURCE_ACTIONS.RESOURCE_ACTION_ALL
          }"
          class="d-inline-block text-danger"
          @click="handleDeleteIconClick(data.item)"
        >
          <feather-icon
            v-b-tooltip.hover
            title="Eliminar"
            icon="TrashIcon"
            size="18"
          />
        </b-link>
      </template>
    </BaseTable>
    <b-modal v-model="showIncidents" title="Facturas con  incidencia" hide-footer centered>
      <div> 
        <table class="mb-2 table p-1">
          <thead><tr><th>Descripción</th><th>Importe</th></tr></thead>
          <tbody>
          <tr v-for="(incident, idx) in incidentsList" :key="idx">
            <td>{{ incident.description }}</td>
            <td>{{ incident.amount | numberToLocalString  }}€</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div>
        <table class="mt-1 table table-striped p-1" v-if="currentOrder.jobExpectedCostLine">
          <thead><tr><th colspan="2">COSTE PREVISTO AFECTADO</th></tr></thead>
          <tbody>
          <tr>
            <td><strong>Descripción:</strong></td><td>{{ currentOrder.jobExpectedCostLine.description || 0 }}</td> 
          </tr>
          <tr>
            <td><strong>Previsión inicial:</strong></td><td>{{ (currentOrder.jobExpectedCostLine.initial_prevision === 0 || currentOrder.jobExpectedCostLine.initial_prevision) ? currentOrder.jobExpectedCostLine.initial_prevision : 0 | numberToLocalString }}€</td>
          </tr>
          <tr>
            <td><strong>Prevision viva:</strong></td><td>{{ (currentOrder.jobExpectedCostLine.prevision === 0 || currentOrder.jobExpectedCostLine.prevision) ? currentOrder.jobExpectedCostLine.prevision : 0 | numberToLocalString }}€</td>
          </tr>
          <tr>
            <td><strong>Desviación:</strong></td><td>{{ (currentOrder.jobExpectedCostLine.deviation === 0 || currentOrder.jobExpectedCostLine.deviation) ? currentOrder.jobExpectedCostLine.deviation : 0 | numberToLocalString }}€</td>
          </tr>
          <tr>
            <td><strong>Pedido:</strong></td><td>{{ ((currentOrder.jobExpectedCostLine.order === 0 || currentOrder.jobExpectedCostLine.order) ?  currentOrder.jobExpectedCostLine.order : 0 ) | numberToLocalString }}€</td>
          </tr>  
          <tr>
            <td><strong>Pendiente:</strong></td><td>{{ ((currentOrder.jobExpectedCostLine.pendent === 0 || currentOrder.jobExpectedCostLine.pendent) ?  currentOrder.jobExpectedCostLine.pendent : 0 ) | numberToLocalString }}€</td>
          </tr>     
          </tbody>
        </table>
      </div>
      <div class="mt-1">
         <p>¿Quieres resolver las incidencias?</p>
         <p>Si el total de los pedidos supera la previsión viva se realizará el ajuste correspondiente.</p>
      </div>
       <div class="d-flex justify-content-between pt-1">
        <button class="btn btn-secondary me-2" @click="showIncidents = false">Cancelar</button>
        <button class="btn btn-primary" @click="resolveIncidents">Resolver</button>
      </div>
    </b-modal>
    <OrdersListFilters
      ref="orders-list-filters"
      v-model="filtersVisible"
      @filters-submit="$store.commit('orders/setFilters', $event)"
    />
  </div>
</template>

<script>
import OrdersApi from '@/api/orders-api'
import { STATUS_BADGE_PARTIAL_INVOICED } from '@/shared/constants/statusBadges'
import OrdersListFilters from '@/components/orders/filters/OrdersListFilters.vue'
import StatusBadge from '@/components/status/badge/StatusBadge.vue'
import BaseTable from '@/components/ui/table/BaseTable.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'OrdersTable',
  components: { BaseTable, StatusBadge, OrdersListFilters },
  props: {
    providerId: {
      type: Number,
      default: null,
    },
    totalsConfiguration: {
      type: Array,
      default: () => [
        { colspan: 6 },
        { label: 'TOTAL PNDT. DE FACT', key: 'total_pending_billing', unit: '€' },
        { label: 'TOTAL BRUTO', key: 'total_gross', unit: '€' },
        { label: 'TOTAL IVA', key: 'total_order', unit: '€' },
         { colspan: 1 },
      ],
    },
  },
  data() {
    return {
      loading: false,
      filtersVisible: false,
      showIncidents: false,
      incidentsList: [],
      currentOrderId: null,
      currentOrder: {},
    }
  },
  computed: {
    ...mapGetters({
      filters: 'orders/getFilters',
    }),
    baseExcludeFilters() {
      const excludedFilters = []
      if (this.providerId) {
        excludedFilters.push('provider_id')
      }

      return excludedFilters
    },
    baseFilters() {
      const filters = { ...this.filters }
      if (this.providerId) {
        filters.provider_id = this.providerId
      }
      return filters
    },
    columns() {
      const items = [
        {
          label: 'REF JOB',
          key: 'job',
          sortable: true,
          thStyle: { 'min-width': '100px' },
        },
        {
          label: 'Nº PEDIDO',
          key: 'number',
          sortable: true,
          thStyle: { 'min-width': '150px' },
        },
        {
          label: 'FECHA PEDIDO',
          key: 'order_date',
          sortable: true,
        },
      ]

      if (!this.providerId) {
        items.push({
          label: 'PROVEEDOR',
          key: 'provider',
          sortable: true,
        })
      }

      return items.concat([
        {
          label: 'ESTADO FACTURACIÓN',
          key: 'status',
          sortable: true,
        },
        {
          label: 'ESTADO ALB.',
          key: 'status_notes',
          sortable: true,
        },
        {
          label: 'PNDT. DE FACT.',
          key: 'pending_billing',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
          thStyle: { 'min-width': '140px' },
        },
        {
          label: 'T.BRUTO',
          key: 'total_gross',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
          thStyle: { 'min-width': '110px' },

        },
        {
          label: 'TOTAL IVA',
          key: 'total_order',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
          thStyle: { 'min-width': '110px' },
        },
        {
          label: '',
          key: 'invoices_incidents',
          sortable: false,
          thStyle: { 'min-width': '150px' },
        },
        {
          label: 'ACCIONES',
          key: 'actions',
          sortable: false,
          thClass: 'text-right pr-2',
          tdClass: 'text-right pr-2',
          thStyle: { 'min-width': '210px' },
        },
      ])
    },
  },
  methods: {
    showIncidentsModal(incidents, order) {
      this.incidentsList = incidents
      this.currentOrder = order
      this.currentOrderId = order.id
      this.showIncidents = true
    },
    async resolveIncidents() {
      this.showIncidents = false;

      try {
        const orderId = this.currentOrderId || (this.incidentsList[0]?.order_id);
        if (!orderId) {
          this.$toast.error('No se pudo determinar el pedido para resolver incidencias.');
          return;
        }
        const response = await this.$root.constructor.prototype.$http.post(`/orders/fix-invoice-incident/${orderId}`);
        if (response.status === 200 && response.data?.message) {
          this.$toast(response.data.message);
          // Recargar la tabla
          if (this.$refs['orders-table'] && this.$refs['orders-table'].loadData) {
            this.$refs['orders-table'].loadData();
          }
        } else {
          this.$toast.error('No se pudo resolver la incidencia.');
        }
      } catch (error) {
        const msg = error.response?.data?.message || 'Error al resolver la incidencia.';
        this.$toast.error(msg);
      }
    },
    handleClearOfferListFilters() {
      this.$store.commit('orders/setFilters', null)
      this.$refs['orders-list-filters'].clearFilters()
    },
    getStatusText(order) {
      if (order.status?.name.toLowerCase() !== STATUS_BADGE_PARTIAL_INVOICED.status) {
        return order.status.name
      }

      return `${order.status.name} ${order.billed_percentage} %`
    },
    async handlePrintLinkClick(orderId) {
      this.loading = true
      try {
        await OrdersApi.printOrder(orderId)
      } finally {
        this.loading = false
      }
    },
    async handleDeleteIconClick(order) {
      const response = await this.$modal.show({
        title: '¿Está seguro?',
        text: `Se borrará el registro Nº${order.number}.`,
      })

      if (!response.isConfirmed) {
        return
      }

      this.loading = true
      try {
        await OrdersApi.delete(order.id)
        await this.$refs['orders-table'].loadData()
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
/* Ocupa todo el ancho y padding */
.orders-table-container {
  width: 100%;
  padding: 16px 24px;
  box-sizing: border-box;
}

h5 {
  font-size: 1.25rem;
  font-weight: 500;
}
li,p {
  font-size: 1rem;
}
/* Forzar la tabla a ocupar el 100% del ancho */
::v-deep .b-table {
  width: 100% !important;
}
</style>
